/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V2ReplaceFileMetaData } from '../models/V2ReplaceFileMetaData';
import { HttpFile } from '../http/http';

/**
* Request to replace the target file with a new file.
*/
export class V2ReplaceTargetFileRequest {
    'metadata'?: V2ReplaceFileMetaData;
    /**
    * The actual source file.
    */
    'chunk'?: string;
    /**
    * Id of the org to which the target belongs
    */
    'orgId': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "V2ReplaceFileMetaData",
            "format": ""
        },
        {
            "name": "chunk",
            "baseName": "chunk",
            "type": "string",
            "format": "byte"
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": "uuid"
        }    ];

    static getAttributeTypeMap() {
        return V2ReplaceTargetFileRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

